import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Download, Trash2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function DataPrivacy() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [confirming, setConfirming] = useState(false);
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const exportData = async () => {
    try {
      const { data } = await api.get("/account/export", { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "lismoi-mes-donnees.json";
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await api.post("/account/delete", { password });
      toast.success("Votre compte et vos données ont été supprimés.");
      navigate("/", { replace: true });
      await logout().catch(() => {});
    } catch (e) {
      toast.error(formatApiError(e));
      setBusy(false);
    }
  };

  return (
    <div data-testid="data-privacy-box" className="card-paper mt-5 p-5">
      <div className="flex items-center gap-2 font-display text-xl font-bold"><ShieldCheck size={20} className="text-[color:var(--sage)]" /> Mes données</div>
      <p className="mt-1 text-sm text-[color:var(--muted-ink)]">Sans publicité, sans revente. Vous gardez la main.</p>
      <button data-testid="data-export-button" onClick={exportData} className="btn-ghost mt-4 w-full !py-2 text-sm"><Download size={16} /> Exporter mes données</button>
      {!confirming ? (
        <button data-testid="data-delete-button" onClick={() => setConfirming(true)} className="mt-3 flex w-full items-center justify-center gap-2 text-sm font-bold text-[color:var(--terracotta)] underline">
          <Trash2 size={16} /> Supprimer mon compte et mes données
        </button>
      ) : (
        <div data-testid="data-delete-confirm" className="mt-4 rounded-2xl bg-[#FCE9E5] p-4">
          <p className="text-sm font-semibold">Cette action est définitive : progrès, histoires créées et abonnement (annulé immédiatement) seront supprimés. Saisissez votre mot de passe pour confirmer.</p>
          <input data-testid="data-delete-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-3 w-full rounded-xl border-2 border-[color:var(--line)] px-3 py-2 outline-none focus:border-[color:var(--terracotta)]" placeholder="Mot de passe" />
          <div className="mt-3 flex gap-2">
            <button data-testid="data-delete-cancel-button" onClick={() => { setConfirming(false); setPassword(""); }} className="btn-ghost flex-1 !py-2 text-sm">Annuler</button>
            <button data-testid="data-delete-confirm-button" disabled={busy || !password} onClick={remove} className="btn-primary flex-1 !py-2 !text-sm">Supprimer</button>
          </div>
        </div>
      )}
    </div>
  );
}
